<template>
  <el-dialog
    title="新增监控链接"
    :visible.sync="storeAlinkShow"
    :close-on-click-modal="false"
    :show-close="false"
    width="640px"
    id="dialog">
    <el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
      <div class="seaerch-wrapper">
        <el-form :label-width="labelWidth" id="shopLink">
          <el-form-item label="平台" :required="true">
            <el-select v-model="plateformValue" size="small" clearable placeholder="请选择" style="width: 440px;">
              <el-option
                v-for="item in platformList"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="添加链接" prop="arrLink" class="require">
              <div class="link_content">
                <div class="link_div_container">
                  <div
                    class="link_div"
                    v-for="(item,index) in ruleForm.arrLink"
                    :key="index"
                    v-show="ruleForm.arrLink.length>0"
                  >
                    <span
                      v-show="!linkEditShow[index]"
                      :class="ifcheckLink[index]==false?'redlink':''"
                      class="ellipsis"
                    >{{item}}</span>
                    <el-input
                      v-model="link"
                      size="small"
                      v-if="linkEditShow[index]"
                      @blur="blurEditLink(index)"
                    ></el-input>
                    <div style="width: 34px;">
                      <i class="el-icon-edit-outline" @click="editeLink(index)"></i>
                      <i class="el-icon-close" @click="removeLink(index)"></i>
                    </div>
                  </div>
                </div>
                <el-input
                  clearable
                  v-model="ruleForm.link"
                  size="small"
                  placeholder="一行一个，可多个，最多50个。"
                  @blur="convertLink"
                  :disabled="checkDisabled"
                ></el-input>
              </div>
            </el-form-item>
            <el-form-item>
              <el-button
                size="small"
                @click="handleCheckTrue"
                :disabled="checkDisabled"
                :loading="checkLoading"
              >验证链接</el-button>
              <el-button size="small" style="float:right" @click="delRedLink" class="delRedLink">刪除爆红链接</el-button>
              <div style="color: #FAAD14;">
                可监控链接数量上限：{{chiLdNum}}/{{allLimitProNum}}
              </div>
            </el-form-item>
        </el-form>
      </div>
    </el-row>
    <span slot="footer">
      <el-button size="small" type="primary" @click="sure">确 定</el-button>
      <el-button size="small" type="TheCustom" @click="cancel">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { handleProductUrl } from "@/libs";
import { getItemId } from "@/libs/index";
import { mapMutations } from "vuex";

export default {
  props: {

  },
  data() {
    return {
      newitemIds: '',
      noticeids: '',
      priceType: '',
      totalNum: 0,
      chiLdNum: 0,
      allLimitProNum: 0,
      labelWidth: '100px',
      plateformValue: '',
      ruleForm: {
        arrLink: [],
        link: "" //用户输入的链接
      },
      platformList: [],
      linkEditShow: [],
      ifcheckLink: [], //判断是否验证通过
      checkLink: [], //验证的链接
      checkDisabled: false,
      link: "",
      tureLink: [], //正确的链接
      tureLinkObj: [],
      storeAlinkShow: false,
      checkLoading: false,
      toSecondbtn: true,
    };
  },
  watch: {
      plateformValue(val,oldVal){
        this.plateformValue=val
      },
  },
  methods: {
    ...mapMutations(["changeitemIds"]),
    faOpen(data) {
      console.log(data)
      this.link = ''
      this.ruleForm.link = ''
      this.ruleForm.arrLink = []
      this.plateformValue = ''
      this.priceType = data.radio
      this.chiLdNum = data.totalNum
      this.totalNum = data.totalNum
      this.allLimitProNum = data.allLimitProNum
      this.storeAlinkShow = true
      this.platformList = data.shopmonitorPlatform
    },
    delRedLink() {
      //删除爆红链接
      for (var i = this.ifcheckLink.length - 1; i >= 0; i--) {
        if (!this.ifcheckLink[i]) {
          this.ruleForm.arrLink.splice(i, 1);
          this.ifcheckLink.splice(i, 1);
        }
      }
      this.chiLdNum = 0
      this.chiLdNum = this.totalNum + this.ruleForm.arrLink.length
      this.$emit("delFalseLink");
      this.toSecondbtn = false
    },
    verifiedRepeat(arr) {
      let verityData = arr.substring(1, arr.length - 1).split(",");
      this.ruleForm.arrLink.forEach((item, index) => {
        verityData.forEach(items => {
          if (item.indexOf(items.replace(/\s+/g, "")) > -1) {
            this.$set(this.ifcheckLink, index, false);
          }
        });
      });
    },
    //信用积分举报链接时用到.验证失败爆红
    reportLinkCheck(arr) {
      arr.forEach((items, index) => {
        if (items.reason == 1 || items.reason == 2 || !items.itemid) {
          //重复链接
          this.$set(this.ifcheckLink, this.tureLinkObj[index].index, false); //爆红链接
          if (items.reason == 1 || items.reason == 2)
            this.$emit("haveRepeatUrl");
        }
      });
      this.checkRedLink();
      let errorLink=this.ifcheckLink.filter(item=>{return !item})
      if (errorLink.length > 0) {
        this.$message.error("存在" + errorLink.length + "条链接验证失败");
      } else {
        this.$message.success("成功");
      }
       this.checkLoading = false;
       this.checkDisabled = false;
    },
    //判断是否有验证失败的链接
    checkRedLink() {
      this.haveRedLink = [];
      this.haveRedLink = this.ifcheckLink.filter(item => {
        return item == false;
      });
    },
    // 先调用转换
    convertLink() {
      let xiugailink = this.ruleForm.link.split(' ')
      let params = {
        link: xiugailink.join(','),
        platform: this.plateformValue
      }
      fetch({
        url: "hcm/monitorLink/convertLink",
        method: "get",
        noFormat: true,
        responseType: "text",
        params: params,
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          this.ruleForm.link = ''
          this.ruleForm.link = data.join(' ')
          this.blurLink()
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },
    blurLink() {
      if (this.ruleForm.link) {
        //链接输入框失去焦点，处理数据
        let stringLink = this.ruleForm.link.replace(/http/g, "~http");
        let arrLink = stringLink.split("~");
        arrLink.splice(0, 1);
        arrLink.forEach((item, i) => {
          if (item.indexOf("tmall") != -1 || item.indexOf("taobao") != -1) {
            if (!this.ifUrlSku) {
              var str_before = item.split("?")[0];
              let id = this.getLinkQueryString(item);
              item = str_before + "?id=" + id;
            } else {
              item = handleProductUrl(item);
            }
            arrLink[i] = item;
          }
          this.linkEditShow.push(false);
          if (this.needHttps) {
            item = item.replace("http://", "https://");
          }
          // 展示用的数组
          this.ruleForm.arrLink.push(item);
        });
        console.log(this.ruleForm.arrLink)
        console.log(this.ruleForm.link)
        if (this.ruleForm.arrLink.length > 0) {
          this.chiLdNum = 0
          this.chiLdNum = this.totalNum + this.ruleForm.arrLink.length
        }
        this.ruleForm.link = "";
      }
    },
    getLinkQueryString(string) {
      var reg = new RegExp("(^|&|[?])id=([^&]*)(&|$)");
      var regs = new RegExp("(^|&|[?])itemid=([^&]*)(&|$)");
      var r = string.substr(1).match(reg) || string.substr(1).match(regs);
      var newName = r != null ? r[2] : "";
      return newName;
    },
    editeLink(index) {
      //编辑链接
      this.linkEditShow.forEach((item, i) => {
        if (i == index) this.$set(this.linkEditShow, i, true);
        else this.$set(this.linkEditShow, i, false);
      });
      this.link = this.ruleForm.arrLink[index];
    },
    removeLink(index) {
      //删除链接
      console.log(this.totalNum)
      this.ruleForm.arrLink.splice(index, 1);
      this.ifcheckLink.splice(index, 1);
      this.chiLdNum = 0
      this.chiLdNum = this.totalNum + this.ruleForm.arrLink.length
      this.$emit("delFalseLink", index);
    },
    blurEditLink(index) {
      if (!/http/.test(this.link)) {
        this.$message.warning("请输入带有http的链接");
        return;
      }
      //编辑链接失去焦点时
      let stringLink = this.link.replace(/http/g, "~http");
      let arrLink = stringLink.split("~");
      arrLink.splice(0, 1);
      if (arrLink.length > 0) {
        arrLink.forEach((link, i) => {
          let url = handleProductUrl(link);
          if (i === 0) {
            this.ruleForm.arrLink[index] = url;
            this.$set(this.linkEditShow, index, false);
          } else {
            this.linkEditShow.splice(index + i, 0, false);
            this.ruleForm.arrLink.push(url);
          }
        });
      } else {
        this.ruleForm.arrLink[index] = handleProductUrl(this.link);
      }
      this.$set(this.linkEditShow, index, false);
    },
    // 验证是否符合规则
    handleCheckTrue() {
      if (!this.ruleForm.arrLink[0]) {
        this.$message.error("请输入正确的链接进行验证");
        return false;
      }
      this.vertifyLinkRepeat();
      let _this = this;
      if (this.ruleForm.arrLink.length > 50) {
        setTimeout(() => {
          _this.$message.error("监控链接不能多于50条");
        });
        return false;
      }
      if (this.canChekNum && this.ruleForm.arrLink.length > this.canChekNum) {
        setTimeout(() => {
          _this.$message.error("添加链接超过上限，请删除部分链接");
        });
        return false;
      }
      //储存可以验证的正确链接
      this.tureLink = [];
      this.tureLinkObj = [];
      this.ruleForm.arrLink.map((item, index) => {
        if (this.ifcheckLink[index]) {
          this.tureLinkObj.push({ url: item, index: index });
          this.tureLink.push(item);
        }
      });
      if (this.tureLink.length > 0) {
        this.checkLinks(this.tureLink)
        this.checkDisabled = true;
        this.checkLoading = true;
      }else{
        this.$message.error(`存在${this.ruleForm.arrLink.length}链接验证失败`);
      }
    },
    vertityLinkFlow() {
      if (!this.plateformValue) {
        this.$message.error("请选择监控平台");
        return false;
      }
      if (!this.ruleForm.radio) {
        this.$message.error("请选择监控类型");
        return false;
      }
      this.$refs.refcheckLink.handleCheckTrue();
    },
    // 链接验证接口
    checkLinks(params) {
      let itemIds = [];
      params.forEach(item => {
        itemIds.push(getItemId(item));
      });
      
      this.newitemIds = itemIds.join(",")
      this.changeitemIds(this.newitemIds);
      
      let data = {
        platform: this.plateformValue,
        priceType: this.priceType,
        itemIds: this.newitemIds
      };
      fetch({
        url: "hcm/monitorLink/verifiedLink",
        method: "post",
        data: data,
        timeout: 60 * 1000 * 10
      }).then(res => {
        if (res.status === "10000") {
          if (!/false/.test(res.data)&&!/服务器异常/.test(res.data)) {
            this.noticeids=res.data
            this.ruleForm.allcheckLinks = 1;
            // this.$message.success("验证链接成功,已自动剔除无效链接");
            this.$message.success("成功");
            this.changecheckDisabled();
            this.toSecondbtn = false;

          } else {
            this.$message.error("验证链接失败!");
          }
          this.checkDisabled = false
        } else if(res.status === "10004"){
          this.$message.error(res.message);
          this.verifiedRepeat(res.data);
          this.toSecondbtn = true;
          this.checkDisabled = true
          this.cancheckDisabled();
        }
         this.filechangecheckDisabled();
      }).catch(()=>{
        this.filechangecheckDisabled();
        this.cancheckDisabled();
      })
    },
    changecheckDisabled() {
      this.checkDisabled = true;
    },
    cancheckDisabled() {
      this.checkDisabled = false;
    },
    filechangecheckDisabled() {
      this.checkLoading = false;
      // this.$message.success("成功");
    },
    // 验证是否是当前平台下的链接
    vertifyLinkInPlatform(platform) {
      if (platform) {
        if (platform === "TB") {
          this.handleRepeatData("item.taobao.com");
        } else if (platform === "TM") {
          this.handleRepeatData("detail.tmall.com", "yao.95095.com",'detail.liangxinyao.com','detail.tmall.hk');
        } else if (platform === "SN") {
          this.handleRepeatData("product.suning.com");
        } else if (platform === "JD") {
          this.handleRepeatData("item.jd.com",'item.jd.hk','item.yiyaojd.com');
        } else if (platform === "PDD") {
          this.handleRepeatData("mobile.yangkeduo.com");
        } else if (platform === "WPH") {
          this.handleRepeatData("detail.vip.com");
        } else if (platform === "1688") {
          this.handleRepeatData("detail.1688.com");
        } else if (platform === "DD") {
          this.handleRepeatData("product.dangdang.com");
        } else if (platform === "YFW") {
          this.handleRepeatData("yaofangwang.com");
        } else if (platform === "YYC") {
          this.handleRepeatData("yaoex.com");
        } else if (platform === "LZDVN") {
          this.handleRepeatData("www.lazada.vn");
        } else if (platform === "LZDSG") {
          this.handleRepeatData("www.lazada.sg");
        } else if (platform === "LZDMY") {
          this.handleRepeatData("www.lazada.com.my");
        }
      }
    },
    handleRepeatData(str1, str2,str3,str4) {
      let redHint = false;
      this.ruleForm.arrLink.forEach((link, index) => {
        if (link.indexOf(str1) > -1 || link.indexOf(str2) > -1 || link.indexOf(str3) > -1 || link.indexOf(str4) > -1) {
          this.$set(this.ifcheckLink, index, true);
        } else {
          redHint = true;
          this.$set(this.ifcheckLink, index, false);
        }
      });
      // if (redHint) {
      //   this.$message.error("请删除不属于该平台的链接");
      // }
    },
    // 验证链接是否重复
    vertifyLinkRepeat() {
      var vecotr = {};
      this.ifcheckLink = [];
      let delIndex = 0;
      let arr = this.ruleForm.arrLink;
      for (let i = arr.length - 1; i >= 0; i--) {
        if (arr[i].indexOf("goods") !== -1) {
          var str_before = arr[i].split("?")[0];
          let id = getItemId(arr[i]);
          arr[i] = str_before + "?goods_id=" + id;
        }
        arr[i] = arr[i].replace(/\s+/g, "");
        if (arr[i]) {
          if (!vecotr[arr[i]]) {
            vecotr[arr[i]] = true;
            continue;
          }
          ++delIndex;
          this.ruleForm.arrLink.splice(i, 1);
        }
      }
      if (delIndex > 0) {
        this.$message.success(`已自动删除了${delIndex}条重复链接`);
      }
      this.chiLdNum = 0
      this.chiLdNum = this.totalNum + this.ruleForm.arrLink.length
      console.log(this.ruleForm.arrLink)
      console.log(this.plateformValue)
      this.vertifyLinkInPlatform(this.plateformValue);
    },
    chenkitem(checkedLink, unpassCount) {
      if (checkedLink.length == 0 && unpassCount > 0) {
        this.$message.error("存在" + unpassCount + "条链接验证失败");
        return false;
      }
      let params = {
        itemlinks: checkedLink.join(","),
        platform: this.plateformValue
      };
    },
    cancel() {
      let newParams = this.ruleForm.arrLink
      let itemIds = [];
      newParams.forEach(item => {
        itemIds.push(getItemId(item));
      });
      this.changeitemIds(itemIds.join(","));
      let data = {
        itemids: itemIds.join(",")
      };
      fetch({
        url: "hcm/monitorLink/deleteNewMonitorlinkrepeat",
        method: "post",
        data: data,
        timeout: 60 * 1000 * 10
      }).then(res => {
        if (res.status === "10000") {
          this.storeAlinkShow = false
        }
      })
    },
    sure() {
      if (!this.plateformValue) {
        this.$message({
          message: '请选择平台',
          type: 'warning'
        });
        return
      }
      if (this.ruleForm.arrLink.length == 0) {
        this.$message({
          message: '请添加链接',
          type: 'warning'
        });
        return
      }
      if (this.toSecondbtn == true) {
        this.$message({
          message: '请删除错误链接',
          type: 'warning'
        });
        return
      }
      let arr = []
      arr = Array.from(new Set(this.ruleForm.arrLink))
      console.log(arr)
      let params={
        itemIds: this.newitemIds,
      }
      fetch({
        url: "hcm/monitorLink/newMonitorList",
        method: "get",
        params: params,
        noFormat: true,
        responseType: "text"
      }).then(result => {
        let res = JSON.parse(result);
        let {data}=res
        if(res.status == '10000'){
          let newdata = {
            noticeids: this.noticeids,
            data: data
          }
          this.storeAlinkShow = false
          this.$emit('fromChild', newdata)
          // }
        } else {
          this.$message({
            message: res.message,
            type: "error"
          });
        }
      })
    },

  }
};
</script>
<style lang="scss">
#shopLink {
  .ellipsis {
    width: 90%;
  }
  .link_content {
    padding: 10px;
    border: 1px solid #dcdfe6;
    height: 252px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 440px;
    .link_div_container {
      max-height: 200px;
      overflow-y: auto;
    }
    .el-input__inner {
      border: none;
    }
  }
  .require .el-form-item__label {
    &::before {
      content: "*";
      color: #f56c6c;
      margin-right: 4px;
    }
  }
  .link_div {
    height: 24px;
    line-height: 24px;
    border: 1px solid #dcdfe6;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    justify-content: space-between;
    padding-right: 5px;
    box-sizing: border-box;
    margin-bottom: 5px;
    border-radius: 4px;
    .el-input--small .el-input__inner {
      height: 18px;
      line-height: 18px;
      border: none;
    }
  }
  .el-icon-edit-outline {
    font-size: 14px;
    color: #108cee;
  }
  .redlink {
    color: red;
  }
  #dialog {
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
}
</style>
